var render = function render(){var _vm=this,_c=_vm._self._c;return _c(`${_vm.node.data.object.type}-widget`,{tag:"component",attrs:{"widget":_vm.node.data},on:{"show-enlarged":_vm.showEnlarged}})
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }